import { faShoppingCart } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePortalSlug } from 'rental/app/AppContext';
import { slugs } from 'rental/app/steps';
import { ReactBootstrapModal } from 'shared/components/ReactModal';
import { AppExpiredInfo } from 'shared/urql';


export interface Props {
  info?: AppExpiredInfo | null;
}


export const AppExpiredModal = ({ info }: Props) => {
  const portalSlug = usePortalSlug();
  const continueLink = `/${portalSlug}/${slugs.cart}`;

  return (
    <>
      <ReactBootstrapModal
        title="Sorry, your session has expired"
        isOpen={info?.expired ?? false}
        onRequestClose={() => {
          document.location.href = continueLink;
        }}
        className="text-center"
      >
        <p className="mt-3"><b>To protect your privacy</b>, your personal details have been cleared.  We do this automatically after an hour of in-activity.  Please fill them in again.</p>
        <p className="text-success">
          <FontAwesomeIcon icon={faShoppingCart} /> Your cart will still contain the item(s) you have previously added.
        </p>
        <a className="btn btn-primary mr-2 mb-2" href={continueLink}>Continue</a>
      </ReactBootstrapModal>
    </>
  );
}
